import React, { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import { useSelector } from 'react-redux';

import Tag from './Tag';
import { ICONS } from '../../../icons';
import Icon from '../../../icons/Icon';

import scss from './TagList.module.scss';

function TagList({ tags, onClickTag, isExpandable }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [hasOverflow, setHasOverflow] = useState(false);
  const listRef = useRef(null);

  const { tags: filterTags } = useSelector((state) => state.activ8.tableSettings.filters);

  const handleExpand = () => {
    setIsExpanded(true);
  };

  const handleHide = () => {
    setIsExpanded(false);
  };

  useEffect(() => {
    if (!listRef.current || isExpanded) return;
    const el = listRef.current;
    setHasOverflow(el.scrollHeight > el.clientHeight);
  }, [tags, isExpanded]);

  const showExpandTrigger = isExpandable && !isExpanded && hasOverflow;

  return (
    <div className={scss.wrapper}>
      <ul
        className={clsx(scss.tagList, (isExpanded || !isExpandable) && scss.expanded)}
        ref={listRef}
        data-collapsed={(!isExpanded && isExpandable) || undefined}>
        {tags?.map((tag) => (
          <Tag
            key={tag}
            tag={tag}
            onClick={onClickTag}
            isSelected={filterTags.some((filterTag) => filterTag.value === tag)}
          />
        ))}
      </ul>
      {showExpandTrigger && (
        <button type='button' className={scss.expandTrigger} onClick={handleExpand} aria-label='Show all tags'>
          •••
        </button>
      )}
      {isExpandable && isExpanded && (
        <button type='button' className={scss.hideTrigger} onClick={handleHide}>
          <Icon icon={ICONS.EyeCrossed} />
        </button>
      )}
    </div>
  );
}

export default TagList;
